import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = { class: "text-body-1" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = { class: "text-body-1" }
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = { class: "text-body-1" }
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = { class: "text-body-1" }
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = { class: "text-body-1" }
const _hoisted_11 = { class: "mb-3" }
const _hoisted_12 = { class: "text-body-1" }
const _hoisted_13 = { class: "mb-3" }
const _hoisted_14 = { class: "text-body-1" }
const _hoisted_15 = { class: "mb-3" }
const _hoisted_16 = { class: "text-body-1" }
const _hoisted_17 = { class: "mb-3" }
const _hoisted_18 = { class: "text-body-1" }
const _hoisted_19 = { class: "mb-3" }
const _hoisted_20 = { class: "text-body-1" }
const _hoisted_21 = { class: "mb-3" }
const _hoisted_22 = { class: "text-body-1" }
const _hoisted_23 = { class: "mb-3" }
const _hoisted_24 = { class: "text-body-1" }
const _hoisted_25 = ["colspan"]
const _hoisted_26 = { class: "mb-2" }
const _hoisted_27 = { class: "text-body-2" }
const _hoisted_28 = { class: "mb-2" }
const _hoisted_29 = { class: "text-body-2" }
const _hoisted_30 = { class: "mb-2" }
const _hoisted_31 = { class: "text-body-2" }
const _hoisted_32 = { class: "mb-2" }
const _hoisted_33 = { class: "text-body-2" }
const _hoisted_34 = { class: "mb-2" }
const _hoisted_35 = { class: "text-body-2" }
const _hoisted_36 = { class: "mb-2" }
const _hoisted_37 = { class: "text-body-2" }
const _hoisted_38 = { class: "mb-2" }
const _hoisted_39 = { class: "text-body-2" }
const _hoisted_40 = { class: "mb-2" }
const _hoisted_41 = { class: "text-body-2" }
const _hoisted_42 = { class: "mb-2" }
const _hoisted_43 = { class: "text-body-2" }
const _hoisted_44 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_45 = { class: "text-body-2 text-error" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        justify: "center",
        align: "start",
        class: "mt-4"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            md: "4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: $setup.policyNumber,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.policyNumber) = $event)),
                label: "Policy Number",
                variant: "outlined",
                density: "comfortable",
                onKeyup: _withKeys($setup.getTrackers, ["enter"])
              }, null, 8 /* PROPS */, ["modelValue", "onKeyup"])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_v_col, { cols: "auto" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                color: "primary",
                onClick: $setup.getTrackers,
                loading: $setup.loading,
                disabled: !$setup.policyNumber
              }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode(" Get Tracker ")
                ])),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["onClick", "loading", "disabled"])
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }),
      ($setup.trackers.length > 0)
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 0,
            justify: "center",
            align: "start"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                md: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select, {
                    modelValue: $setup.selectedTrackerId,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.selectedTrackerId) = $event)),
                    items: $setup.trackerOptions,
                    "item-title": "text",
                    "item-value": "value",
                    label: "Select Form Tracker",
                    variant: "outlined",
                    density: "comfortable"
                  }, null, 8 /* PROPS */, ["modelValue", "items"])
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" Tracker Details "),
      ($setup.selectedTracker)
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 1,
            justify: "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                md: "9"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_text, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                              _createCommentVNode(" Column 1 "),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                md: "4"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_1, [
                                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-caption text-medium-emphasis" }, "ID", -1 /* HOISTED */)),
                                    _createElementVNode("div", _hoisted_2, _toDisplayString($setup.selectedTracker.id), 1 /* TEXT */)
                                  ]),
                                  _createElementVNode("div", _hoisted_3, [
                                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text-caption text-medium-emphasis" }, "Policy Number", -1 /* HOISTED */)),
                                    _createElementVNode("div", _hoisted_4, _toDisplayString($setup.selectedTracker.policyNumber), 1 /* TEXT */)
                                  ]),
                                  _createElementVNode("div", _hoisted_5, [
                                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-caption text-medium-emphasis" }, "Amendment Number", -1 /* HOISTED */)),
                                    _createElementVNode("div", _hoisted_6, _toDisplayString($setup.selectedTracker.amendmentNumber ?? 'N/A'), 1 /* TEXT */)
                                  ]),
                                  _createElementVNode("div", _hoisted_7, [
                                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-caption text-medium-emphasis" }, "Date Started", -1 /* HOISTED */)),
                                    _createElementVNode("div", _hoisted_8, _toDisplayString($setup.formatDateTime($setup.selectedTracker.dateStarted)), 1 /* TEXT */)
                                  ])
                                ]),
                                _: 1 /* STABLE */
                              }),
                              _createCommentVNode(" Column 2 "),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                md: "4"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_9, [
                                    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "text-caption text-medium-emphasis" }, "Date Finished", -1 /* HOISTED */)),
                                    _createElementVNode("div", _hoisted_10, _toDisplayString($setup.selectedTracker.dateFinished ? $setup.formatDateTime($setup.selectedTracker.dateFinished) : 'N/A'), 1 /* TEXT */)
                                  ]),
                                  _createElementVNode("div", _hoisted_11, [
                                    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "text-caption text-medium-emphasis" }, "Has Interactive Forms", -1 /* HOISTED */)),
                                    _createElementVNode("div", _hoisted_12, _toDisplayString($setup.selectedTracker.hasInteractiveForms), 1 /* TEXT */)
                                  ]),
                                  _createElementVNode("div", _hoisted_13, [
                                    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "text-caption text-medium-emphasis" }, "Interactive Forms Generated", -1 /* HOISTED */)),
                                    _createElementVNode("div", _hoisted_14, _toDisplayString($setup.selectedTracker.interactiveFormsGenerated), 1 /* TEXT */)
                                  ]),
                                  _createElementVNode("div", _hoisted_15, [
                                    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "text-caption text-medium-emphasis" }, "Has Policy Forms", -1 /* HOISTED */)),
                                    _createElementVNode("div", _hoisted_16, _toDisplayString($setup.selectedTracker.hasPolicyForms), 1 /* TEXT */)
                                  ])
                                ]),
                                _: 1 /* STABLE */
                              }),
                              _createCommentVNode(" Column 3 "),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                md: "4"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_17, [
                                    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "text-caption text-medium-emphasis" }, "Policy Forms Generated", -1 /* HOISTED */)),
                                    _createElementVNode("div", _hoisted_18, _toDisplayString($setup.selectedTracker.policyFormsGenerated), 1 /* TEXT */)
                                  ]),
                                  _createElementVNode("div", _hoisted_19, [
                                    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "text-caption text-medium-emphasis" }, "Document Rules Executed", -1 /* HOISTED */)),
                                    _createElementVNode("div", _hoisted_20, _toDisplayString($setup.selectedTracker.documentRulesExecuted), 1 /* TEXT */)
                                  ]),
                                  _createElementVNode("div", _hoisted_21, [
                                    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "text-caption text-medium-emphasis" }, "Documents Blended", -1 /* HOISTED */)),
                                    _createElementVNode("div", _hoisted_22, _toDisplayString($setup.selectedTracker.documentsBlended), 1 /* TEXT */)
                                  ]),
                                  _createElementVNode("div", _hoisted_23, [
                                    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "text-caption text-medium-emphasis" }, "Is Completed", -1 /* HOISTED */)),
                                    _createElementVNode("div", _hoisted_24, _toDisplayString($setup.selectedTracker.isCompleted), 1 /* TEXT */)
                                  ])
                                ]),
                                _: 1 /* STABLE */
                              })
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" Policy Forms Table "),
      ($setup.selectedTracker && $setup.selectedTracker.policyForms?.length > 0)
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 2,
            justify: "center",
            class: "mt-4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                md: "9"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_title, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Policy Forms (" + _toDisplayString($setup.selectedTracker.policyForms.length) + ")", 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_v_card_text, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_data_table, {
                            headers: $setup.policyFormsHeaders,
                            items: $setup.selectedTracker.policyForms,
                            expanded: $setup.expandedForms,
                            "item-value": "formCode",
                            "show-expand": "",
                            density: "comfortable"
                          }, {
                            [`item.formGenerationStatus`]: _withCtx(({ item }) => [
                              _createVNode(_component_v_chip, {
                                color: item.formGenerationStatus?.errorMessage ? 'error' : 'success',
                                size: "small"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.formGenerationStatus?.errorMessage ? 'Error' : 'Success'), 1 /* TEXT */)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["color"])
                            ]),
                            "expanded-row": _withCtx(({ columns, item }) => [
                              _createElementVNode("tr", null, [
                                _createElementVNode("td", {
                                  colspan: columns.length,
                                  class: "pa-4 bg-grey-lighten-4"
                                }, [
                                  _createVNode(_component_v_row, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        md: "4"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_26, [
                                            _cache[15] || (_cache[15] = _createElementVNode("div", { class: "text-caption font-weight-bold text-primary" }, "GhostDraft Company", -1 /* HOISTED */)),
                                            _createElementVNode("div", _hoisted_27, _toDisplayString(item.ghostDraftCompany ?? 'N/A'), 1 /* TEXT */)
                                          ]),
                                          _createElementVNode("div", _hoisted_28, [
                                            _cache[16] || (_cache[16] = _createElementVNode("div", { class: "text-caption font-weight-bold text-primary" }, "Document Service Name", -1 /* HOISTED */)),
                                            _createElementVNode("div", _hoisted_29, _toDisplayString(item.ghostDraftDocumentServiceName ?? 'N/A'), 1 /* TEXT */)
                                          ]),
                                          _createElementVNode("div", _hoisted_30, [
                                            _cache[17] || (_cache[17] = _createElementVNode("div", { class: "text-caption font-weight-bold text-primary" }, "Package Name", -1 /* HOISTED */)),
                                            _createElementVNode("div", _hoisted_31, _toDisplayString(item.ghostDraftPackageName ?? 'N/A'), 1 /* TEXT */)
                                          ])
                                        ]),
                                        _: 2 /* DYNAMIC */
                                      }, 1024 /* DYNAMIC_SLOTS */),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        md: "4"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_32, [
                                            _cache[18] || (_cache[18] = _createElementVNode("div", { class: "text-caption font-weight-bold text-primary" }, "Package Version", -1 /* HOISTED */)),
                                            _createElementVNode("div", _hoisted_33, _toDisplayString(item.ghostDraftPackageVersion ?? 'N/A'), 1 /* TEXT */)
                                          ]),
                                          _createElementVNode("div", _hoisted_34, [
                                            _cache[19] || (_cache[19] = _createElementVNode("div", { class: "text-caption font-weight-bold text-primary" }, "GhostDraft Form Name", -1 /* HOISTED */)),
                                            _createElementVNode("div", _hoisted_35, _toDisplayString(item.ghostDraftFormName ?? 'N/A'), 1 /* TEXT */)
                                          ]),
                                          _createElementVNode("div", _hoisted_36, [
                                            _cache[20] || (_cache[20] = _createElementVNode("div", { class: "text-caption font-weight-bold text-primary" }, "Is Static", -1 /* HOISTED */)),
                                            _createElementVNode("div", _hoisted_37, _toDisplayString(item.isStatic), 1 /* TEXT */)
                                          ])
                                        ]),
                                        _: 2 /* DYNAMIC */
                                      }, 1024 /* DYNAMIC_SLOTS */),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        md: "4"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_38, [
                                            _cache[21] || (_cache[21] = _createElementVNode("div", { class: "text-caption font-weight-bold text-primary" }, "Recipients", -1 /* HOISTED */)),
                                            _createElementVNode("div", _hoisted_39, _toDisplayString(item.recipients?.join(', ') ?? 'N/A'), 1 /* TEXT */)
                                          ]),
                                          _createElementVNode("div", _hoisted_40, [
                                            _cache[22] || (_cache[22] = _createElementVNode("div", { class: "text-caption font-weight-bold text-primary" }, "Transaction Types", -1 /* HOISTED */)),
                                            _createElementVNode("div", _hoisted_41, _toDisplayString(item.transactionTypes?.join(', ') ?? 'N/A'), 1 /* TEXT */)
                                          ]),
                                          _createElementVNode("div", _hoisted_42, [
                                            _cache[23] || (_cache[23] = _createElementVNode("div", { class: "text-caption font-weight-bold text-primary" }, "Action Codes", -1 /* HOISTED */)),
                                            _createElementVNode("div", _hoisted_43, _toDisplayString(item.actionCodes?.join(', ') ?? 'N/A'), 1 /* TEXT */)
                                          ]),
                                          (item.formGenerationStatus?.errorMessage)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                                _cache[24] || (_cache[24] = _createElementVNode("div", { class: "text-caption font-weight-bold text-error" }, "Error Message", -1 /* HOISTED */)),
                                                _createElementVNode("div", _hoisted_45, _toDisplayString(item.formGenerationStatus.errorMessage), 1 /* TEXT */)
                                              ]))
                                            : _createCommentVNode("v-if", true)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                      }, 1024 /* DYNAMIC_SLOTS */)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1024 /* DYNAMIC_SLOTS */)
                                ], 8 /* PROPS */, _hoisted_25)
                              ])
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["headers", "items", "expanded"])
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}